var E = /* @__PURE__ */ ((L) => (L[L.LOYALTY = 1] = "LOYALTY", L[L.ONLINE = 2] = "ONLINE", L[L.DELIVERY = 3] = "DELIVERY", L[L.SHOP = 4] = "SHOP", L[L.PAY = 5] = "PAY", L[L.KIOSK = 6] = "KIOSK", L[L.RETAIL = 7] = "RETAIL", L))(E || {});
export {
  E as Channel
};
//# sourceMappingURL=channels.js.map
